export default __webpack_public_path__ + "static/default-3843766253335f0a33b7e2b6d1f72a85.png";